import React from 'react';
import { MonitorIcon, MoonIcon, SunIcon } from 'lucide-react';
import { ThemePreference, useTheme } from '../../contexts/ThemeContext';
const OPTIONS: {
  value: ThemePreference;
  label: string;
  Icon: typeof SunIcon;
}[] = [{
  value: 'system',
  label: 'System',
  Icon: MonitorIcon
}, {
  value: 'light',
  label: 'Light',
  Icon: SunIcon
}, {
  value: 'dark',
  label: 'Dark',
  Icon: MoonIcon
}];

/**
 * A three-state choice, not a toggle: "follow my system" is a distinct
 * intention from "always light". Selection is announced through `aria-checked`
 * rather than colour alone, and the System option says which theme it is
 * currently resolving to so the state is never ambiguous.
 */
export function ThemeControl({
  layout = 'compact'
}: {
  layout?: 'compact' | 'full';
}) {
  const {
    preference,
    theme,
    setPreference
  } = useTheme();
  return <div role="radiogroup" aria-label="Appearance" className={`flex items-center gap-0.5 rounded-lg border border-line bg-canvas p-0.5 ${layout === 'full' ? 'w-full' : ''}`} data-id="element-5367" data-mp="1almoaxji057q">
      {OPTIONS.map(({
      value,
      label,
      Icon
    }) => {
      const selected = preference === value;
      const hint = value === 'system' ? `System — currently ${theme}` : `${label} appearance`;
      return <button key={value} type="button" role="radio" aria-checked={selected} title={hint} onClick={() => setPreference(value)} className={`flex min-h-touch items-center justify-center gap-1.5 rounded-md px-2.5 text-caption font-semibold transition-colors duration-150 ease-out ${layout === 'full' ? 'flex-1' : ''} ${selected ? 'bg-surface text-ink shadow-sm' : 'text-ink-subtle hover:text-ink'}`} data-id="element-5368" data-mp="2t49rp2r92dnm">
            <Icon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-5369" data-mp="deymudbpkbvl" />
            <span className={layout === 'full' ? '' : 'sr-only sm:not-sr-only'} data-id="element-5370" data-mp="8kuebpmsnvse">{label}</span>
          </button>;
    })}
    </div>;
}